import { Box } from '@mui/material';
import { WsTitleBanner } from 'wisestep-base';

import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';

import TeamList from './components/TeamList';
import { getSettingBreadCrumbList, ISettingBreadCrumbTypes, Pages } from './helper/defaultValues';

const TeamPageContent = () => <TeamList />;

const TeamsPage = () => {
  return (
    <>
      <Box py={3}>
        <WsBreadCrumbs
          breadCrumbsList={getSettingBreadCrumbList(
            ISettingBreadCrumbTypes.TEAMS_AND_USERS,
            Pages['TEAMS']
          )}
        />
        <WsTitleBanner title={'Teams'} backButton={false} />
      </Box>

      <TeamPageContent />
    </>
  );
};

export default TeamsPage;
